import imgIndozi from "./images/indizo-file-screen shot.png";
import imgCar from "./images/Car App SS.png";
import imgSpace from "./images/Space landingPage -ss.png";
import imgBestBuy from "./images/BestBuy web.png";
import imgOdd from "./images/Odd Landscape ss.png";

export const WebData = [
  {
    id: 0,
    img: imgBestBuy,
    desc: "BestBuy E-commerce",
    url: "https://my-best-buy.vercel.app/",
    html: "Html",
    css: "css",
    js: "JavaScript",
    tool: "react",
  },
  {
    id: 1,
    desc: "Landing page",
    img: imgOdd,
    url: "https://my-minimal-app.vercel.app/",
    html: "Html",
    css: "css",
    js: "JavaScript",
    js: "typescript",
  },
  {
    id: 2,
    img: imgCar,
    desc: "ODDCARS",
    url: "https://car-app-nine.vercel.app/",
    html: "Html",
    css: "css",
    js: "JavaScript",
    tool: "react",
  },
  {
    id: 3,
    img: imgSpace,
    desc: "Space Tourism",
    url: "https://space-tourism-nine-xi.vercel.app/",
    html: "Html",
    css: "css",
    js: "JavaScript",
  },
  
   {
    id: 4,
    desc: "Landing page",
    img: imgIndozi,
    url: "https://indizo-file.vercel.app/",
    html: "Html",
    css: "css",
    js: "JavaScript",
  },
  
];
